// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6x5bh","requiredAsterisk":"Info_requiredAsterisk__CubVl"};